<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>BOM 组件</h2>
    </div>
    <p v-if="message" class="ok">{{ message }}</p>
    <div class="attr-row add">
      <select v-model="bomDraft.category">
        <option value="cpu">CPU</option>
        <option value="motherboard">主板</option>
        <option value="memory">内存</option>
        <option value="ssd">SSD</option>
        <option value="gpu">GPU</option>
      </select>
      <input v-model="bomDraft.name" placeholder="名称" />
      <input v-model="bomDraft.unit_price" placeholder="单价" />
      <input v-model="bomDraft.currency" placeholder="CNY" />
      <label class="check"><input v-model="bomDraft.published" type="checkbox" /> 上架</label>
      <button type="button" class="btn primary sm" @click="saveBomDraft">添加</button>
    </div>
    <div v-for="item in bomList" :key="item.id" class="attr-row">
      <select v-model="item.category">
        <option value="cpu">CPU</option>
        <option value="motherboard">主板</option>
        <option value="memory">内存</option>
        <option value="ssd">SSD</option>
        <option value="gpu">GPU</option>
      </select>
      <input v-model="item.name" />
      <input v-model="item.unit_price" />
      <input v-model="item.currency" />
      <label class="check"><input v-model="item.published" type="checkbox" /> 上架</label>
      <button type="button" class="btn ghost sm" @click="saveBomItem(item)">保存</button>
      <button type="button" class="btn ghost sm" @click="removeBomItem(item)">删</button>
    </div>

    <h3>服务器模板</h3>
    <div class="attr-row add">
      <input v-model="tplDraft.name" placeholder="模板名，如 8卡训练机" />
      <input v-model="tplDraft.idsText" placeholder="组件ID，逗号分隔，如 1,2,3" />
      <label class="check"><input v-model="tplDraft.published" type="checkbox" /> 发布</label>
      <button type="button" class="btn primary sm" @click="saveTplDraft">添加模板</button>
    </div>
    <div v-for="tpl in bomTemplates" :key="tpl.id" class="list-item">
      <div>
        <strong>{{ tpl.name }}</strong>
        <span class="muted"> · {{ tpl.component_ids_json }}</span>
        <span v-if="!tpl.published" class="warn"> 未发布</span>
      </div>
      <button type="button" class="btn danger sm" @click="removeTpl(tpl)">删除</button>
    </div>
  </section>
</template>

<script>
import {
  adminCreateBomComponent,
  adminCreateBomTemplate,
  adminDeleteBomComponent,
  adminDeleteBomTemplate,
  adminListBomComponents,
  adminListBomTemplates,
  adminUpdateBomComponent
} from '../../api/platformService'

const emptyDraft = () => ({ category: 'gpu', name: '', unit_price: '', currency: 'CNY', published: true })
const emptyTpl = () => ({ name: '', idsText: '', published: true })

export default {
  name: 'AdminBom',
  data() {
    return {
      bomList: [],
      bomTemplates: [],
      bomDraft: emptyDraft(),
      tplDraft: emptyTpl(),
      message: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.bomList = await adminListBomComponents()
      this.bomTemplates = await adminListBomTemplates()
    },
    async saveBomDraft() {
      if (!this.bomDraft.name.trim()) return
      await adminCreateBomComponent(this.bomDraft)
      this.bomDraft = emptyDraft()
      this.bomList = await adminListBomComponents()
      this.message = 'BOM 组件已添加'
    },
    async saveBomItem(item) {
      await adminUpdateBomComponent(item.id, item)
      this.message = '已保存'
    },
    async removeBomItem(item) {
      if (!window.confirm(`删除「${item.name}」？`)) return
      await adminDeleteBomComponent(item.id)
      this.bomList = this.bomList.filter((row) => row.id !== item.id)
    },
    async saveTplDraft() {
      if (!this.tplDraft.name.trim()) return
      const ids = this.tplDraft.idsText.split(/[,，\s]+/).map((x) => Number(x)).filter(Boolean)
      await adminCreateBomTemplate({
        name: this.tplDraft.name,
        component_ids: ids,
        published: this.tplDraft.published
      })
      this.tplDraft = emptyTpl()
      this.bomTemplates = await adminListBomTemplates()
      this.message = '模板已添加'
    },
    async removeTpl(tpl) {
      if (!window.confirm(`删除模板「${tpl.name}」？`)) return
      await adminDeleteBomTemplate(tpl.id)
      this.bomTemplates = this.bomTemplates.filter((row) => row.id !== tpl.id)
    }
  }
}
</script>
